exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.button--count[data-v-0059bdab] {\n    line-height: .4;\n}\n", ""]);

// exports
